import axios from "../../lib/axiosInstance";

export function fetchBankAccounts({ userId, page = 1, limit = 20, search = "" }) {
  const params = new URLSearchParams();
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);

  return axios
    .get(`bankDetails/user/${userId}?${params.toString()}`)
    .then((res) => res.data);
}

export function updateBankAccount(payload) {
  const { id, ...rest } = payload;
  return axios.patch(`bankDetails/${id}`, rest).then((res) => res.data);
}

export function createBankAccount(payload) {
  return axios.post(`bankDetails`, payload).then((res) => res.data);
}

export function deleteBankAccount(payload) {
  return axios
    .delete(`bankDetails/${payload.id}/${payload.userId}`)
    .then((res) => res.data);
}

// Only id/bankName/currency, for pickers such as the invoice form. The full
// records (account numbers and the rest) come from fetchBankAccounts.
export function fetchUserBankAccountDetails(userId) {
  return axios
    .get(`bankDetails/user/${userId}/bankAccountDetails`)
    .then((res) => res.data);
}

export function fetchAllBankAccountsByBranch(id) {
  return axios.get(`bankDetails/${id}`).then((res) => res.data);
}
